export default "__VITE_ASSET__CQ4KYLls__"